import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { PORT } from "../../config";
import "./SearchTeacher.css";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import Pagination from "../../Components/Pagination/Pagination";
import { notify } from "react-notify-toast";
import CollegePageContainer from "../Container/CollegePageContainer";
import { connect } from "react-redux";
import { addRemoveFavouriteTeacher } from "../../redux/college/college.actions";
import { API } from "../../API";
import SearchCard from "../../Components/SearchCard/SearchCard";
import { filterTeacherCriterias, getClassCategories } from "../../Helper";
import SearchBar from "../../Components/SearchBar/SearchBar";
import Spinner from "../../Components/Spinner/Spinner";
import { Divider } from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import SearchTeacherFilter from "../../Components/SearchTeacherFilter/SearchTeacherFilter";
import { TablePagination } from "@mui/material";
import SearchECECTeacherFilter from "../../Components/SearchTeacherFilter/SearchECECTeacherFilter";

const FavouriteTeachers = (props) => {
  let [isLoaded, setIsLoaded] = useState(false);
  let [pageNum, setPageNum] = useState(1);
  let [favTeachers, setFavTeachers] = useState([]);
  let [showCurrentUsers, setShowCurrentUsers] = useState([]); // current page of results
  let [searchResults, setSearchResults] = useState([]); // all search results
  let [searchKeyword, setSearchKeyword] = useState("");
  let [searchLocation, setSearchLocation] = useState("");
  let [searchCategory, setSearchCategory] = useState("");
  const [_englishCatExpanded, setEnglishCatExpanded] = useState(false);
  const [_vetCatExpanded, setVetCatExpanded] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentFilter, setCurrentFilter] = useState({})
  const [paginationInfo, setPaginationInfo] = useState( 
    {total_page: null, total_record: null}
  )

  useEffect(() => {
    const strSearch = window.localStorage.getItem('searchTeacherFilter')
		if(strSearch) {
			const currentSearch = JSON.parse(strSearch)
			setCurrentFilter(currentSearch)
      props.user?.is_childcare_centre ? onSearchECECTeacher({
        ...currentSearch
      }, rowsPerPage)
      : onSearchTeacher({
        ...currentSearch
      }, rowsPerPage)
		}
    else {
      props.user?.is_childcare_centre ? onSearchECECTeacher({
        ...currentFilter
      }, rowsPerPage) : onSearchTeacher({
        ...currentFilter
      }, rowsPerPage)
    }
  }, []);

  // Calculate pages -----
  const pages = () => {
    let arr = [];
    if (searchResults.length != 0 && searchResults.length % 10 == 0) {
      for (let i = 1; i <= searchResults.length / 10; i++) {
        arr.push(i);
      }
    } else if (searchResults.length == 0) {
    } else if (searchResults.length != 0 && searchResults.length % 10 != 0) {
      for (let i = 1; i <= searchResults.length / 10 + 1; i++) {
        arr.push(i);
      }
    }
    return arr;
  };

  // Show 10 users per page ------
  let handlePage = (pageNumber, teachers, rowsPerPage = 8) => {
    setShowCurrentUsers(teachers);
    setPageNum(pageNumber);
  };

  const onPageNumChange = (e, value = 0) => {
    props.user?.is_childcare_centre ? onSearchECECTeacher(currentFilter, rowsPerPage, value + 1) : onSearchTeacher(currentFilter, rowsPerPage, value + 1)
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    props.user?.is_childcare_centre ? onSearchECECTeacher(currentFilter, value) : onSearchTeacher(currentFilter, value)
  }

  const onSearchTeacher = (filter, limit, page = 1) => {
    filter.limit = limit
    filter.page = page
    delete filter.full_can_delivers
    delete filter.vetQualificationSearch
    setCurrentFilter(filter)
    setIsLoaded(false);
    API.searchTeacherWithFilter({
      ...filter,
      institution_id: props.institution._id,
      type: 'favorite'
    }).then((result) => {
      const allTeachers = result.data.data;
      setFavTeachers(allTeachers);
      setSearchResults(allTeachers);
      handlePage(page, allTeachers, limit);
      setPaginationInfo(result.data.paginate)
      setIsLoaded(true);

    })
  }

  let categories = getClassCategories();

  const search = ({ keyword, category, location }) => {
    let kw = (keyword !== undefined ? keyword : searchKeyword).toLowerCase();
    let cat = (category !== undefined
      ? category
      : searchCategory
    ).toLowerCase();
    
    let catArr = [];
    switch (cat) {
      case "all":
        catArr = [];
        break;
      case "all-eng":
        catArr = categories.filter(c => c.type === "eng").map(c => c.value);
        break;
      case "all-vet":
        catArr = categories.filter(c => c.type === "vet").map(c => c.value);
        break;
      default:
        catArr = [cat];
        break;
    }

    let loc = (location !== undefined
      ? location
      : searchLocation
    ).toLowerCase();

    if (kw || cat || loc) {
      if (favTeachers.length > 0) {
        let filteredTeachers = favTeachers.filter((teacher) => {
          let searchFilter = filterTeacherCriterias(teacher);

          let catMatch = false;
          for (let c of catArr) {
            if (searchFilter.category.includes(c)) catMatch = true;
          }
          if (!catArr.length) catMatch = true;

          return (
            searchFilter.keyword.includes(kw) &&
            catMatch &&
            searchFilter.location.includes(loc)
          );
        });
        handlePage(pageNum, filteredTeachers);
        setSearchResults(filteredTeachers);
        pages();
      }
    } else {
      setSearchResults(favTeachers);
      handlePage(pageNum, favTeachers);
      pages();
    }
  };

  const onSearchECECTeacher = (filter, limit, page = 1) => {
    filter.limit = limit
    filter.page = page
    delete filter.full_can_delivers
    delete filter.vetQualificationSearch
    setCurrentFilter(filter)
    setIsLoaded(false);
    API.searchECECTeacherWithFilter({
      ...filter,
      institution_id: props.institution._id,
      type: 'favorite'
    })
    .then((result) => {
      const teachers = result.data.data
      setFavTeachers(teachers);
      setSearchResults(teachers);
      handlePage(page, teachers, limit);
      setPaginationInfo(result.data.paginate)
      setIsLoaded(true);
    }).catch((error) => {
      setIsLoaded(true);
      console.log(error)
    })
  }

  const tabs = [
    {
      text: "Search",
      pathname: "/SearchTeachers",
    },
    {
      text: "My Hires",
      pathname: "/MyHires",
    },
    {
      text: "Favourites",
      pathname: "/FavouriteTeachers",
      active: true,
    },
    {
      text: "Block List",
      pathname: "/BlockedTeachers"
    }
  ];

  return (
    <CollegePageContainer
      user={props.user}
      header="Search Educators"
      tabs={tabs}
      viewbookings={props.viewbookings}
    >
      <div className="search-teacher-container">
      {!props.user?.is_childcare_centre ? <SearchTeacherFilter 
        onSearchTeacher={(filter) => onSearchTeacher(filter, rowsPerPage)}
        user={props.user}
      /> : <SearchECECTeacherFilter
      onSearchTeacher={(filter) => onSearchECECTeacher(filter, rowsPerPage)}
      user={props.user}
    />}
        <div className="search-teacher-main">
          <div className="d-flex flex-wrap justify-content-center">
            {searchResults.length ? (
              showCurrentUsers.map((user) => {
                return (
                  <SearchCard
                    user={user}
                    isFaved={props.institution.fav_teacher_list.includes(
                      user._id
                    )}
                    isBlocked={props.institution.block_list &&
                      props.institution.block_list.includes(user._id)}
                    showBookTeacherButton
                  />
                );
              })
            ) : isLoaded ? (
              <div>
                You have no favourites to display.
                <Link to="/SearchTeachers">{props.user.is_childcare_centre ? "Search Educators" : "Search Teachers"}</Link>&nbsp;and
                click on the heart to add to your favourites.
              </div>
            ) : (
              <Spinner small />
            )}
          </div>

          {searchResults.length && isLoaded ? (
            <div>
              <TablePagination
                component="div"
                count={paginationInfo?.total_record}
                page={pageNum - 1}
                onPageChange={(e, page) => onPageNumChange(e, page)}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10, 25, 50]}
                size="large"
                onRowsPerPageChange={(e) => handleChangeRowsPerPage(e.target.value)}
                showFirstButton
                showLastButton
              />
            </div>
          ) : null}
        </div>
      </div>
    </CollegePageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    // viewbookings: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.vi_book) : 1,
    viewbookings: state.college.permissions.vi_book,
  };
}

const mapDispatchToProps = {
  addRemoveFavouriteTeacher,
};

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteTeachers);
